/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DomainHAStatusDto } from './DomainHAStatusDto';

export type DomainHAEntry = {
    name: string;
    phase?: DomainHAEntry.phase;
    status: DomainHAStatusDto;
};

export namespace DomainHAEntry {

    export enum phase {
        COMPLETED = 'COMPLETED',
        PENDING = 'PENDING',
        RUNNING = 'RUNNING',
    }


}

